import React, { useState } from 'react';
import imgEditar from '../../../assets/icons/edit.png';

const EditButton = ({ closeModal }) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    setIsClicked(!isClicked);
  };

  const buttonStyles = {
    backgroundImage: `url(${imgEditar})`,
    backgroundSize: 'contain',
    width: '25px',
    height: '25px',
    backgroundColor: isClicked ? 'var(--info)' : 'var(--surface-3)',
    color: isClicked ? 'var(--text-primary)' : 'var(--text-on-accent)',
    border: '2px solid',
    borderRadius: '20px',
    padding: '15px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s, box-shadow 0.3s, transform 0.3s',
    boxShadow: isClicked ? 'none' : 'var(--shadow-sm)',
    transform: isClicked ? 'translate(2px, 2px)' : 'translate(0, 0)',
  };

  // Defina o estilo de cor do texto inicialmente como branco quando a tela é aberta
  if (!isClicked) {
    buttonStyles.color = 'var(--text-primary)';
  }

  return (
    <div style={{ width: '100%', padding: '5px' }}>
      <button
        style={buttonStyles}
        onMouseEnter={(e) => {
          if (!isClicked) {
            e.target.style.transform = 'translate(-2px, -2px)';
            e.target.style.boxShadow = 'var(--shadow-md)';
            e.target.style.backgroundColor = 'var(--warning)';
            e.target.style.border = '2px solid var(--accent)';
            e.target.style.color = 'var(--text-on-accent)';
          }
        }}
        onMouseDown={(e) => {
          if (!isClicked) {
            e.target.style.backgroundColor = 'var(--accent-soft)';
            e.target.style.boxShadow = 'none';
            e.target.style.transform = 'translate(1px, 1px)';
          }
        }}
        onMouseUp={(e) => {
          if (!isClicked) {
            e.target.style.backgroundColor = 'var(--accent-soft)';
            e.target.style.boxShadow = 'none';
            e.target.style.transform = 'translate(0, 0)';
            handleClick();
          }
        }}
        onMouseLeave={(e) => {
          if (!isClicked) {
            e.target.style.transform = 'translate(0, 0)';
            e.target.style.boxShadow = 'var(--shadow-sm)';
            e.target.style.backgroundColor = 'var(--surface-3)';
            e.target.style.border = '2px solid white';
            e.target.style.color = 'var(--text-primary)';
          }
        }}
        onClick={(e) => {
          e.stopPropagation();
          closeModal();
        }}
      >
      </button> 
    </div>
  );
};

export default EditButton;
